import { useAppRouter } from '@/common/route/useAppRouter';
import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarColorEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        id: route.params.colorId,
        name: '',
        color: '',
        totalItemImages: null,
        canDelete: false
    });

    const validations = {
        name: { required },
        color: { required, format: validateFormat(/^[0-9A-Fa-f]{6}$/) }
    };

    const v$ = useVuelidate(validations, model);

    const actions = {
        fetch: executeAction({
            request: () => avatarService.color.get(model.id),
            onSuccess: ({ data }) => Object.assign(model, data),
            onError: () => router.push({ name: ROUTE_NAME_AVATAR.COLOR.INDEX })
        }),
        update: excuteAndNotify({
            validator: v$,
            request: () => avatarService.color.update(model.id, model.name, model.color),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.COLOR.INDEX })
        }),
        remove: confirmAndRemove({
            request: () => avatarService.color.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.COLOR.INDEX })
        })
    };

    return { model, v$, actions };
}
